import CustomBodyPublicWizard from './CustomBodyPublicWizard'

export default CustomBodyPublicWizard
